<table class="table">
  <thead>
    <tr class="table-header-row">
      @for (column of columns(); track column) {
        <th class="table-header-cell">
          <ng-container [ngTemplateOutlet]="column.headerCellDef().template" />
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of data(); track row) {
      <tr class="table-row">
        @for (column of columns(); track column) {
          <td class="table-data-cell">
            <ng-container
              [ngTemplateOutlet]="column.cellDef().template"
              [ngTemplateOutletContext]="{ $implicit: row }"
            />
          </td>
        }
      </tr>
    } @empty {
      <tr class="table-row">
        @for (column of columns(); track column) {
          <td class="table-data-cell"></td>
        }
      </tr>
    }
  </tbody>
</table>
